import $ from 'jquery';

$( function() {
  if( $( '.email-wise' ).length ) {
    $( '.email-wise' ).hide();
  }
  
  $('#form').one('submit', function() {
    $(this).find('input[type="submit"]').attr('disabled', 'disabled');
  });
})